import { CircularProgress } from '@mui/material'

import { Center } from './Center'
import { Placeholder } from './Placeholder'


interface LoadingScreenProps {
  title: string
}

export function LoadingScreen({title}: LoadingScreenProps) {
  return (
    <Center>
      <CircularProgress />
      <Placeholder>{ title }</Placeholder>
    </Center>
  )
}